import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { Backend } from '@/ajax/Backend'
const Search = Backend.get('search')
const Rensou = Backend.get('rensou')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    response: {},
    last_action: '',
    current_q: '',
    index: {
      field: '',
      db: ''
    },
    num: 0,
    display: 'grid',
    queries: {},
  },
  getters: {
    response_status: state => {
      if (state.response.info) {
        return state.response.info.status ? state.response.info.status : false
      }
      return false
    },
    response_records: state => {
      if (state.response) {
        if (!state.response.results) {
          return []
        }
        const results = state.response.results
        results.forEach((rec) => { rec.id = rec.fields.__id__[0] })
        return results
      }
    },
    response_facets: state => {
      if (state.response) {
        if (!state.response.facets) {
          return []
        }
        return state.response.facets
      }
    },
    response_total: state => {
      if (state.response.info) {
        return state.response.info.total ? state.response.info.total : 0
      }
      return 0
    },
    response_pages: state => {
      if (state.response.info) {
        if (state.num) {
          return Math.ceil(state.response.info.total / state.num)
        }
      }
      return 0
    },
    last_action: state => {
      return state.last_action
    },
    current_q: state => {
      return state.current_q
    },
    index_field: state => {
      return state.index.field
    },
    index_db: state => {
      return state.index.db
    },
    display: state => {
      return state.display
    },
    queries: state => {
      return state.queries
    },
  },
  mutations: {
    setNum (state, value) {
      state.num = value
    },
    setSearchResponse (state, value) {
      state.response = value
    },
    setRensouResponse (state, value) {
      state.response = value
    },
    setLastAction (state, value) {
      state.last_action = value
    },
    setCurrentQ (state, value) {
      state.current_q = value
    },
    setIndexField (state, value) {
      state.index.field = value
    },
    setIndexDb (state, value) {
      state.index.db = value
    },
    setDisplay (state, value) {
      state.display = value
    },
    setQueries (state, value) {
      state.queries = { ...state.queries, ...value }
    },
    clearResponceStatus (state) {
      if(state.response.info) {
        state.response.info.status = null
      }
    },
  },
  actions: {
    searchObject(context, request) {
      const params = {}
      if (request) {
        // フリーワード
        if (request.fulltext) {
          params.fulltext = request.fulltext
        }
        // 検索対象DB
        if (request.dbs) {
          params.dbs = request.dbs
        }
        // 標本番号
        if (request.id) {
          params.id = request.id
        }
        // 標本名
        if (request.name) {
          params.name = request.name
        }
        // 年代
        if (request.age) {
          params.age = request.age
        }
        // 地域
        if (request.area) {
          params.area = request.area
        }
        // 民族
        if (request.nation) {
          params.nation = request.nation
        }
        // OWC
        if (request.owc) {
          params.owc = request.owc
        }
        // OCM
        if (request.ocm) {
          params.ocm = request.ocm
        }
        // 受入年
        if (request.fyear) {
          params.fyear = request.fyear
        }
        // 言語
        if (request.lang) {
          params.lang = request.lang
        }
        // 1ページあたりの表示数
        if (request.limit) {
          context.commit('setNum', request.limit)
          params.num = request.limit
        }
        // 表示するページ
        if (request.page) {
          params.page = request.page
        }
        // ソート項目
        if (request.sort) {
          params.sort = request.sort
        }
        // ソート順
        if (request.order) {
          params.order = request.order
        }
        // 完全一致用項目
        if (request.exact_fields) {
          params.exact_fields = request.exact_fields
        }
        // ファセット
        if (request.grouping) {
          params.grouping = request.grouping
        }
      } else {
        params.page = 1
      }
      // 検索開始
      context.commit('setLastAction', 'searchObject')
      Search.get(params)
        .then(response => { context.commit('setSearchResponse', response.data) })
        .catch(err => { context.commit('setSearchResponse', false); console.log(err) })
    },
    rensouObject(context, request) {
      const params = []
      // フリーワード
      if (request.freetext) {
        params.freetext = request.freetext
      }
      // 連想元資料＆結果一覧から除外する資料
      if (request.ids) {
        params.ids = request.ids
      }
      // 言語
      if (request.lang) {
        params.lang = request.lang
      }
      // 1ページあたりの表示数
      if (request.limit) {
        params.num = request.limit
      } else {
        params.num = context.state.request.num
      }
      // 表示するページ
      if (request.page) {
        params.page = request.page
      }
      // 連想開始
      context.commit('setLastAction', 'rensouObject')
      Rensou.get(params)
        .then(response => { context.commit('setRensouResponse', response.data) })
        .catch(err => { context.commit('setRensouResponse', false); console.log(err) })
    }
  },
  modules: {
  },
  plugins: [createPersistedState({storage: window.sessionStorage})]
})
